const common = {
  // Shared buttons & labels
  save: 'حفظ',
  cancel: 'إلغاء',
  submit: 'إرسال',
  next: 'التالي',
  back: 'السابق',
  previous: 'السابق',
  confirm: 'تأكيد',
  delete: 'حذف',
  edit: 'تعديل',
  close: 'إغلاق',
  search: 'بحث',
  filter: 'تصفية',
  clear: 'مسح',
  loading: 'جارٍ التحميل...',
  yes: 'نعم',
  no: 'لا',
  viewAll: 'عرض الكل',
  showLess: 'عرض أقل',
  showMore: 'عرض المزيد',
  home: 'الرئيسية',
  dashboard: 'لوحة التحكم',
  settings: 'الإعدادات',
  // Form-related
  emailAddress: 'البريد الإلكتروني',
  password: 'كلمة المرور',
  fullName: 'الاسم الكامل',
  dateOfBirth: 'تاريخ الميلاد',
  address: 'العنوان',
  district: 'المنطقة',
  townCity: 'المدينة / البلدة',
  contactNumber: 'رقم الاتصال',
  mobileNumber: 'رقم الجوال',
  status: 'الحالة',
  actions: 'الإجراءات',
  // UI elements
  noResults: 'لا توجد نتائج',
  noData: 'لا تتوفر بيانات',
  selectOption: 'اختر خياراً',
  required: 'مطلوب',
  optional: 'اختياري',
  // Time
  today: 'اليوم',
  tomorrow: 'غداً',
  yesterday: 'أمس',
  goodMorning: 'صباح الخير',
  goodAfternoon: 'مساء الخير',
  goodEvening: 'مساء الخير',
  // Actions
  upload: 'رفع',
  download: 'تنزيل',
  preview: 'معاينة',
  remove: 'إزالة',
  add: 'إضافة',
  addNew: 'إضافة جديد',
  view: 'عرض',
  viewDetails: 'عرض التفاصيل',
  goBack: 'العودة',
  signOut: 'تسجيل الخروج',
  // Profile & permissions
  profile: 'الملف الشخصي',
  effectivePermissions: 'الصلاحيات الفعالة',
  noPermissions: 'لم يتم تعيين أي صلاحيات للميزات',
  switchRole: 'تبديل الدور',
  roleSwitched: 'تم التبديل إلى دور {{role}}',
  refresh: 'تحديث',
  reset: 'إعادة تعيين',
  retry: 'إعادة المحاولة',
  // Notifications
  markAllRead: 'تعيين الكل كمقروء',
  noNotifications: 'لا توجد إشعارات',
  notifications: 'الإشعارات',
  // Language
  language: 'اللغة',
  // Help
  help: 'مساعدة',
  searchPlaceholder: 'بحث...',
  // Status labels
  active: 'نشط',
  inactive: 'غير نشط',
  pending: 'قيد الانتظار',
  draft: 'مسودة',
  enrolled: 'مسجل',
  enrolledStatus: 'مسجل',
  enrolling: 'قيد التسجيل',
  withdrawn: 'منسحب',
  // Misc
  all: 'الكل',
  none: 'لا شيء',
  other: 'أخرى',
  showing: 'عرض',
  of: 'من',
  results: 'نتائج',
  items: 'عناصر',
  item: 'عنصر',
  students: 'طلاب',
  student: 'طالب',
  teachers: 'معلمين',
  teacher: 'معلم',
  staff: 'الموظفين',
  records: 'سجلات',
  page: 'صفحة',
  na: 'غير متاح',
  notAvailable: 'غير متوفر',
  at: 'في',
  clearAllFilters: 'مسح جميع عوامل التصفية',
  backToDashboard: 'العودة إلى لوحة التحكم',
  showingCount: 'عرض',
  tryAdjustingFilters: 'حاول تعديل البحث أو عوامل التصفية.',
};

export default common;